export const companyDetails = {
  name: 'Barons Eden'
};
